import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
export default {
  /**
   * 
   * @param {*} parmas 
   * @returns 
   * 
   * 查询列表增加参数shopType ,1 智能台灯体验店，2为钢琴灯体验店
   */
  async getStoresData(parmas = {
  }) {
    const url = `/witshop/shoplist/${parmas.areaId}/${parmas.lat}/${parmas.lng}` + (parmas.shopType ? `?shopType=${parmas.shopType}` : "");
    let {data} = await axios({
      url,
      method:'get',
    });
    console.dir({
      axios,
      data
    });
    return data;
  },
  async getCityData(){
    let {data} =await axios.get('/witshop/shoparea');
    return data;
  },
  async getshowBanner(params={}){
    let {data} = await axios(`/witshop/shopbanner/${params.size}`)
    return data
  }
}
